import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        const userSessionKey = 'wa360_session';
        const appCookieKey = 'tokenCookie';
        const sharedCookieKey = 'AuthToken';

        const getTopLevelDomain = (domain) => {
            // this should return only the
            // extension and the top level of the domain
            // ex: futurewalottery.com
            // from stg01.mylottery360.futurewalottery.com
            return domain.split('.').slice(-2).join('.');
        };

        const setCookieValueByName = (cookieName, cookieValue) => {
            if (typeof document === 'undefined') {
                return;
            }

            document.cookie = `${cookieName}=${cookieValue}; Path=/; Domain=${getTopLevelDomain(document.location.hostname)}`;
            return cookieValue;
        };

        let result = await apiClient(config).apiMethod({
            method: 'CTLRegister',
            args: {
                email: payload.email,
                confirm_email: payload.confirm_email,
                password: payload.password,
                confirm: payload.confirm,
                optins: payload.optins,
            },
        });

        if (result.code) {
            return {
                success: false,
                errors: result.code,
            };
        } else {
            return {
                success: true,
                errors: '',
                result: result,
            };
        }
    };
};
